//20250626: xt this was updated to react-bootstrap v2 
import React from 'react'
import { Image, Container } from 'react-bootstrap'
import BSGStar from '../../assets/images/BSGStar.png'
import './Error.css'

const Error = ({
  code = '404',
  desc = 'Page Not Found',
  message = 'The page you requested cannot be found. Please use the top navigation to browse to a different location'
}) => (
  <div className='container p-5 mb-4 bg-light rounded-3' id='error-jumbotron'>
    <div className='text-center'>
      <img 
      src={BSGStar} 
      alt='BSG Star Logo' 
     className='img-fluid mb-4'
     style={{ width: '10%'}} 
       />
      <h2 className='display-4'>
        {code} {code && '-'} {desc}
      </h2>
      <p className='lead'>{message}</p>
    </div>
  </div>
)


export default Error

